﻿import {defineComponent, onMounted, ref} from 'vue';
import {useAnnouncementStore} from "../../../stores/announcement-store";
import {AnnouncementDto, AnnouncementSeverity} from "@/api/enterprise-gateway-api.proxy.ts";
import {userLocalStorage} from "../../helpers/user-local-storage";

export const announcementsStorageKey: string = 'application_announcements';

export default defineComponent({
    name: 'AegApplicationAnnouncements',
    setup() {
        const announcementStore = useAnnouncementStore();
        const announcements = ref<Array<AnnouncementDto>>([]);

        const filterOutClosedAnnouncements = (allAnnouncement: Array<AnnouncementDto>): Array<AnnouncementDto> => {
            if (!allAnnouncement || allAnnouncement.length === 0) {
                return allAnnouncement ?? [];
            }

            const closedAnnouncementIds = userLocalStorage.getItem<string[]>(announcementsStorageKey) ?? [];
            return allAnnouncement.filter(announcement => announcement.id && announcement.severity === AnnouncementSeverity.Warning && !closedAnnouncementIds.includes(announcement.id));
        }
        
        const loadAllAnnouncements = async () => {
            const result = await announcementStore.getActive();
            if (!result) return;

            announcements.value = filterOutClosedAnnouncements(result);
        }

        const closeMessage = (id: string) => {
            userLocalStorage.appendItemToArray(announcementsStorageKey, id);
            announcements.value = announcements.value.filter((announcement) => announcement.id !== id);
        }

        onMounted(async () => {
            await loadAllAnnouncements();
        });

        return {
            announcements,
            closeMessage
        }
    }
});
